import { render, staticRenderFns } from "./product-categories-select.vue?vue&type=template&id=072704f4&scoped=true&"
import script from "./product-categories-select.vue?vue&type=script&lang=js&"
export * from "./product-categories-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072704f4",
  null
  
)

export default component.exports